module.exports = __webpack_public_path__ + "static/media/house-night.1b09889d.svg";